module.exports = __webpack_public_path__ + "img/OBDTracker.34059e99.png";